export default "__VITE_ASSET__DECSQrY1__"